import { useState } from 'react';
import { BladApi, pobierzPlik } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { Przycisk } from './ui';

/** Stronicowanie dotyczy ekranu; arkusz zawsze dostaje wszystkie pasujące wiersze. */
const TYLKO_DLA_EKRANU = new Set(['strona', 'naStronie']);

/**
 * „Pobierz Excel” dla listy. Wysyła te same filtry, które widać na ekranie —
 * serwer użyje dokładnie tej samej logiki co lista, więc plik zawiera
 * wszystkie wiersze spełniające filtr, a nie tylko wyświetloną stronę.
 * Ceny zależą od roli i są ukrywane po stronie serwera.
 */
export function PrzyciskExcel({ dzial, parametry, className = '' }: {
  /** Kod działu z `GET /api/eksport`, np. „kartoteka”. */
  dzial: string;
  /** Filtry listy; `strona` i `naStronie` są pomijane. */
  parametry?: URLSearchParams;
  className?: string;
}) {
  const { maUprawnienie } = useAuth();
  const [trwa, setTrwa] = useState(false);
  const [blad, setBlad] = useState<string | null>(null);

  if (!maUprawnienie('raporty.eksport')) return null;

  async function pobierz() {
    setTrwa(true);
    setBlad(null);
    try {
      const filtry = new URLSearchParams();
      parametry?.forEach((wartosc, klucz) => {
        if (!TYLKO_DLA_EKRANU.has(klucz)) filtry.append(klucz, wartosc);
      });
      const zapytanie = filtry.toString();
      await pobierzPlik(`/eksport/${dzial}${zapytanie ? `?${zapytanie}` : ''}`, `${dzial}.xlsx`);
    } catch (e) {
      setBlad(e instanceof BladApi ? e.message : 'Nie udało się przygotować arkusza.');
    } finally {
      setTrwa(false);
    }
  }

  return (
    <div className={`flex flex-col items-end gap-1 ${className}`}>
      <Przycisk
        onClick={() => void pobierz()}
        disabled={trwa}
        aria-busy={trwa}
        title="Arkusz Excel ze wszystkimi wierszami pasującymi do filtrów — nie tylko z widocznej strony"
      >
        <svg aria-hidden="true" viewBox="0 0 20 20" className="h-4 w-4" fill="none" stroke="currentColor"
          strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 3v9m0 0-3.5-3.5M10 12l3.5-3.5M4 15.5h12" />
        </svg>
        {trwa ? 'Przygotowuję arkusz…' : 'Pobierz Excel'}
      </Przycisk>
      {blad && <p role="alert" className="max-w-xs text-right text-sm text-status-brak">{blad}</p>}
    </div>
  );
}
